<script setup lang="ts">

import { faArrowUpArrowDown, faFilterCircleXmark } from '@fortawesome/pro-regular-svg-icons'

import { BtnIcon, BtnPrimary } from '@shared/ui/buttons'
import { AppInput } from '@shared/ui/inputs'
import { MultiSelectSearchable, NativeSelect } from '@shared/ui/fields'

import { useTutorKanbanFilters } from '../model/tutor-kanban-filters.hook'

defineOptions({
  name: 'TutorKanbanFilters',
})

const {
  filterResetKey,
  searchQuery,
  categoryOptions,
  categoryInitialValue,
  handleCategorySelected,
  strictCategoryOptions,
  strictCategoryValue,
  handleStrictCategoryChange,
  paidLabelOptions,
  paidLabelInitialValue,
  handlePaidLabelSelected,
  agentsOptions,
  agentsInitialValue,
  handleAgentsSelected,
  reasonsOptions,
  reasonsInitialValue,
  handleReasonsSelected,
  sortOptions,
  sortValue,
  handleSortChange,
  handleSearch,
  handleClear,
} = useTutorKanbanFilters()
</script>

<template>
  <div class="tkb-filters">
    <div class="tkb-filters__main">
      <div
        :key="filterResetKey"
        class="tkb-filters__general"
      >
        <AppInput
          v-model="searchQuery"
          label="Search"
          placeholder="Search"
          @keyup:enter="handleSearch"
        />
        <MultiSelectSearchable
          :key="categoryOptions.length"
          class="multiselect-category"
          label="Category"
          placeholder="All"
          :options="categoryOptions"
          :value="categoryInitialValue"
          :is-all-available="true"
          @selected="handleCategorySelected"
        />
        <NativeSelect
          class="strict-select"
          label="Strict Category"
          name="strict-select"
          :options="strictCategoryOptions"
          :value="strictCategoryValue"
          @change="handleStrictCategoryChange"
        />
        <MultiSelectSearchable
          :key="paidLabelOptions.length"
          class="multiselect-paid-label"
          label="Paid Label"
          placeholder="All"
          :options="paidLabelOptions"
          :value="paidLabelInitialValue"
          :is-all-available="true"
          @selected="handlePaidLabelSelected"
        />
        <MultiSelectSearchable
          :key="agentsOptions.length"
          class="multiselect-agents"
          label="Agent"
          placeholder="All"
          :options="agentsOptions"
          :value="agentsInitialValue"
          :is-all-available="true"
          @selected="handleAgentsSelected"
        />
        <MultiSelectSearchable
          :key="reasonsOptions.length"
          class="multiselect-reasons"
          label="Stage reason"
          placeholder="All"
          :options="reasonsOptions"
          :value="reasonsInitialValue"
          :is-all-available="true"
          @selected="handleReasonsSelected"
        />
        <NativeSelect
          class="sort-select"
          label="Sort"
          name="sort-select"
          :icon="faArrowUpArrowDown"
          :options="sortOptions"
          :value="sortValue"
          @change="handleSortChange"
        />
      </div>
      <div class="tkb-filters__controls">
        <BtnPrimary
          text="Search"
          @click="handleSearch"
        />
        <BtnIcon
          :icon="faFilterCircleXmark"
          color="red"
          tooltip-text="Clear filters"
          @click="handleClear"
        />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanFilters.scss" />
